"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ElevationsChartCard = ElevationsChartCard;
var _CardContent2 = _interopRequireDefault(require("@mui/material/CardContent"));
var _Card2 = _interopRequireDefault(require("@mui/material/Card"));
var _CardHeader2 = _interopRequireDefault(require("@mui/material/CardHeader"));
var _ArrowDownward2 = _interopRequireDefault(require("@mui/icons-material/ArrowDownward"));
var _Skeleton2 = _interopRequireDefault(require("@mui/material/Skeleton"));
var _ArrowUpward2 = _interopRequireDefault(require("@mui/icons-material/ArrowUpward"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = require("styled-components");
var _elevationsChart = require("./elevations-chart");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ElevationsChartCard({
  disableElevation,
  route,
  setChart,
  onHighlight
}) {
  return /*#__PURE__*/_react.default.createElement(_Card2.default, {
    sx: {
      borderRadius: 2
    },
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_CardHeader2.default, {
    slotProps: {
      subheader: {
        component: 'div',
        variant: 'body2'
      },
      title: {
        component: 'div',
        variant: disableElevation ? 'body1' : 'h6'
      }
    },
    subheader: /*#__PURE__*/_react.default.createElement(StyledSubheader, null, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_ArrowUpward2.default, {
      fontSize: "small"
    }), route ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, Math.round(route.verticalGain), " m") : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
      variant: "text",
      width: 50
    })), /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_ArrowDownward2.default, {
      fontSize: "small"
    }), route ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, Math.round(route.verticalLoss), " m") : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
      variant: "text",
      width: 50
    }))),
    title: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.routing.detail.elevation_profile"
    })
  }), /*#__PURE__*/_react.default.createElement(StyledCardContent, null, /*#__PURE__*/_react.default.createElement(_elevationsChart.ElevationsChart, {
    onHighlight: onHighlight,
    route: route,
    setChart: setChart
  })));
}
const StyledSubheader = _styledComponents.styled.span`
  display: flex;

  > span {
    align-items: center;
    display: flex;

    svg {
      margin-right: 8px;
    }

    &:not(:first-child) {
      margin-left: 16px;
    }
  }
`;
const StyledCardContent = (0, _styledComponents.styled)(_CardContent2.default)`
  && {
    padding: 16px;
  }
`;